import { Role } from '../../../../../shared/enums/role.enum';
import { SecondarySideMenuI } from '../../../../../shared/interfaces/secondary-side-menu.interface';

export const SIDE_MENU_ITEMS: SecondarySideMenuI[] = [
  {
    translationPath: 'sideMenu.programs',
    activeIcon: 'svgs/side-menu/active-program.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-program.svg',
    route: (departmentID: string) => `departments/${departmentID}/programs`,
    alt: 'Courses',
    roles: [Role.SUPER_ADMIN, Role.ADMIN, Role.DEAN, Role.PROGRAM_MANAGER],
  },
  {
    translationPath: 'sideMenu.courses',
    activeIcon: 'svgs/side-menu/active-course.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-course.svg',
    route: (departmentID: string) => `departments/${departmentID}/courses`,
    alt: 'Courses',
    roles: [Role.SUPER_ADMIN, Role.ADMIN, Role.DEAN, Role.PROGRAM_MANAGER],
  },
  {
    translationPath: 'sideMenu.instructors',
    activeIcon: 'svgs/side-menu/active-instructor.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-instructor.svg',
    route: (departmentID: string) => `departments/${departmentID}/instructors`,
    alt: 'Instructors',
    roles: [Role.SUPER_ADMIN, Role.ADMIN, Role.DEAN, Role.PROGRAM_MANAGER],
  },
  {
    translationPath: 'sideMenu.students',
    activeIcon: 'svgs/side-menu/active-student.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-student.svg',
    route: (departmentID: string) => `departments/${departmentID}/students`,
    alt: 'Students',
    roles: [Role.SUPER_ADMIN, Role.ADMIN, Role.DEAN, Role.PROGRAM_MANAGER],
  },
];
